module.exports = __webpack_public_path__ + "img/2.d00b2075.png";